import { usePlayerStatistics } from '@/api/players';
import Link from '@/components/core/Link';
import useModalVersion from '@/hooks/modals/useModalVersion';
import { Image, ToolTip } from '@starsoft/common/components';
import Color from 'color';
import useTranslation from 'next-translate/useTranslation';
import SkeletonRankedBadge from './Skeleton';
import styles from './styles.module.scss';

export default function RankedBadge() {
  const { versionV2 } = useModalVersion();
  const { t, lang: language } = useTranslation('common');
  const {
    player,
    error: errorRankUser,
    isPending: loadingRankUser,
  } = usePlayerStatistics();

  const labelVip: string = player?.rankStatus?.rank?.name?.[language];
  const imageVip: string = player?.rankStatus?.rank?.group.image;
  const colorVip: string = player?.rankStatus?.rank?.group.color;

  if (errorRankUser) {
    return null;
  }

  if (loadingRankUser) {
    return <SkeletonRankedBadge />;
  }

  return (
    <ToolTip titleComponent={<div>{t('see_vip_club')}</div>}>
      <Link
        href={`/vip-club/?rank-group-id=${player?.rankStatus?.rank?.group?.id}`}
        className={`${styles.container} upper`}
      >
        <div
          style={{
            backgroundColor: colorVip
              ? Color(colorVip).alpha(0.4).toString()
              : undefined,
          }}
          color={colorVip}
          className={`${styles.badge} ${versionV2 ? styles['badge--v2'] : ''}`}
        >
          <Image
            width={20}
            height={20}
            className={styles['badge__image-ranked']}
            src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/ranks/medal/${imageVip}`}
            alt="rank"
          />
          <p className={styles['badge__ranked-vip']}>{labelVip?.[language]}</p>
        </div>
      </Link>
    </ToolTip>
  );
}
